<style>
  .complementos {
    text-align: center;
    margin-top: 55px;
    padding: 0.5rem 1rem;
    max-width: 100vw;
  }
</style>

<template>
  <div class="complementos">
    <ImageGallery class="image-gallery" :image-list="complementos">
    </ImageGallery>
  </div>
</template>

<script>
import ImageGallery from '@/components/ImageGallery.vue'
import { complementos } from '@/complementos.js'

export default {
  name: 'complementos',
  components: {
    ImageGallery
  },
  data () {
    return {
      complementos: complementos()
    }
  }
}
</script>
